import React, { useEffect, useState } from "react";
import axios from "axios";

function DPAFiles({ contract, onClose }) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;

    const [files, setFiles] = useState([]);

    const token = localStorage.getItem("token");

    useEffect(() => {
        fetchFiles();
    }, []);

    const fetchFiles = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/contracts/dpa-files/${contract.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setFiles(response.data);
        } catch (err) {
            console.log(err);
        }
    };

   const downloadFile = async (item) => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/contracts/downloadDpa/${item.id}`,
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const url = window.URL.createObjectURL(response.data);

            const link = document.createElement("a");
            link.href = url;
            link.download = item.filename;
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <div
                className="modal fade show"
                style={{
                    display: "block",
                    background: "rgba(0,0,0,.5)",
                }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">
                                DPA Files
                            </h5>

                            <button
                                className="btn-close"
                                onClick={onClose}
                            ></button>
                        </div>

                        <div className="modal-body">

                            <table className="table table-bordered table-hover">

                                <thead>
                                    <tr>
                                        <th width="60">#</th>
                                        <th>File Name</th>
                                        <th width="150">Download</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {files.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={3}
                                                className="text-center"
                                            >
                                                No DPA Files Found
                                            </td>
                                        </tr>
                                    )}

                                    {files.map((item, index) => (
                                        <tr key={item.id}>

                                            <td>{index + 1}</td>

                                            <td>{item.filename}</td>

                                            <td className="text-center">

                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => downloadFile(item)}
                                                >
                                                    <i className="fa fa-download"></i>
                                                </button>

                                            </td>

                                        </tr>
                                    ))}

                                </tbody>

                            </table>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default DPAFiles;